export interface RecurlyPlan {
    unit: string
    setup_fee: string
}

export interface RecurlyPriceBase {
    addons: { [key: string]: string }
    plan: RecurlyPlan
}
export interface RecurlyPriceNow {
    total: number
    subtotal: number
    plan: number
    discount: number
}
export interface RecurlyPrice {
    addons: { [key: string]: string }
    plan: RecurlyPrice
    base: RecurlyPriceBase
    now: RecurlyPriceNow
    currency: RecurlyPriceCurrency
}
export interface RecurlyPriceCurrency {
    code: string
    symbol: string
}

export enum PaymentInterval {
    Monthly = 1,
    Yearly,
}

export enum PaymentIntervalType {
    ELEVEN_FOR_TWELVE = 0,
    TEN_PERCENT = 1,
}
